import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
	DateTime: any;
	GenericScalar: any;
	JSONString: any;
	PositiveInt: any;
	RichText: any;
	UUID: any;
};

export enum GQLAnswerChoicesEnum {
	A = "A",
	B = "B",
	C = "C",
	D = "D",
	E = "E",
}

export type GQLAnswerMutation = {
	__typename?: "AnswerMutation";
	success?: Maybe<Scalars["Boolean"]>;
};

export type GQLBlockQuoteBlock = GQLStreamFieldInterface & {
	__typename?: "BlockQuoteBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLBooleanBlock = GQLStreamFieldInterface & {
	__typename?: "BooleanBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["Boolean"];
};

export type GQLBusinessIdea = {
	__typename?: "BusinessIdea";
	id?: Maybe<Scalars["ID"]>;
	title?: Maybe<Scalars["String"]>;
};

export type GQLBusinessIdeaType = {
	__typename?: "BusinessIdeaType";
	id: Scalars["ID"];
	profiles?: Maybe<Array<GQLProfileObject>>;
	rating?: Maybe<Scalars["Int"]>;
	title: Scalars["String"];
};

export type GQLCharBlock = GQLStreamFieldInterface & {
	__typename?: "CharBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLChoiceBlock = GQLStreamFieldInterface & {
	__typename?: "ChoiceBlock";
	blockType: Scalars["String"];
	choices: Array<GQLChoiceOption>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLChoiceOption = {
	__typename?: "ChoiceOption";
	key: Scalars["String"];
	value: Scalars["String"];
};

/** Collection type */
export type GQLCollectionObjectType = {
	__typename?: "CollectionObjectType";
	ancestors: Array<Maybe<GQLCollectionObjectType>>;
	depth: Scalars["Int"];
	descendants: Array<Maybe<GQLCollectionObjectType>>;
	id: Scalars["ID"];
	name: Scalars["String"];
	numchild: Scalars["Int"];
	path: Scalars["String"];
};

export type GQLContentPage = GQLPageInterface & {
	__typename?: "ContentPage";
	aliasOf?: Maybe<GQLPage>;
	ancestors: Array<GQLPageInterface>;
	children: Array<GQLPageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<GQLPageInterface>;
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	id?: Maybe<Scalars["ID"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	lockedBy?: Maybe<GQLUser>;
	nextSiblings: Array<GQLPageInterface>;
	numchild: Scalars["Int"];
	owner?: Maybe<GQLUser>;
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<GQLPageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<GQLPageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchImage?: Maybe<GQLImageObjectType>;
	searchScore?: Maybe<Scalars["Float"]>;
	sections?: Maybe<Array<Maybe<GQLContentSection>>>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<GQLPageInterface>;
	sidebar?: Maybe<Array<Maybe<GQLSidebarLink>>>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type GQLContentPageAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLContentPageChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLContentPageDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLContentPageNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLContentPagePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLContentPageSectionsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLContentPageSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLContentSection = {
	__typename?: "ContentSection";
	content?: Maybe<Array<Maybe<GQLStreamFieldInterface>>>;
	id?: Maybe<Scalars["ID"]>;
	slug?: Maybe<Scalars["String"]>;
	title?: Maybe<Scalars["String"]>;
};

export type GQLCreateIdeaMutation = {
	__typename?: "CreateIdeaMutation";
	idea?: Maybe<GQLIdeaType>;
	success?: Maybe<Scalars["Boolean"]>;
};

export type GQLCreateUserMutationInput = {
	clientMutationId?: InputMaybe<Scalars["String"]>;
	email: Scalars["String"];
	firstName?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	industry?: InputMaybe<Scalars["String"]>;
	industrySubcategory?: InputMaybe<Scalars["String"]>;
	lastName?: InputMaybe<Scalars["String"]>;
	password1: Scalars["String"];
	password2: Scalars["String"];
};

export type GQLCreateUserMutationPayload = {
	__typename?: "CreateUserMutationPayload";
	clientMutationId?: Maybe<Scalars["String"]>;
	errors: Array<GQLErrorType>;
	user?: Maybe<GQLUserType>;
};

export type GQLDashboardPage = GQLPageInterface & {
	__typename?: "DashboardPage";
	aliasOf?: Maybe<GQLPage>;
	ancestors: Array<GQLPageInterface>;
	children: Array<GQLPageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<GQLPageInterface>;
	draftTitle: Scalars["String"];
	emptyHelpText?: Maybe<Scalars["RichText"]>;
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	generalHelpText?: Maybe<Scalars["RichText"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	id?: Maybe<Scalars["ID"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	lockedBy?: Maybe<GQLUser>;
	nextSiblings: Array<GQLPageInterface>;
	numchild: Scalars["Int"];
	owner?: Maybe<GQLUser>;
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<GQLPageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<GQLPageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<GQLPageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type GQLDashboardPageAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLDashboardPageChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLDashboardPageDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLDashboardPageNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLDashboardPagePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLDashboardPageSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLDateBlock = GQLStreamFieldInterface & {
	__typename?: "DateBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLDateBlockValueArgs = {
	format?: InputMaybe<Scalars["String"]>;
};

export type GQLDateTimeBlock = GQLStreamFieldInterface & {
	__typename?: "DateTimeBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLDateTimeBlockValueArgs = {
	format?: InputMaybe<Scalars["String"]>;
};

export type GQLDecimalBlock = GQLStreamFieldInterface & {
	__typename?: "DecimalBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["Float"];
};

export type GQLDocumentChooserBlock = GQLStreamFieldInterface & {
	__typename?: "DocumentChooserBlock";
	blockType: Scalars["String"];
	document: GQLDocumentObjectType;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

/**
 * Base document type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type GQLDocumentObjectType = {
	__typename?: "DocumentObjectType";
	collection: GQLCollectionObjectType;
	createdAt: Scalars["DateTime"];
	file: Scalars["String"];
	fileHash: Scalars["String"];
	fileSize?: Maybe<Scalars["Int"]>;
	id: Scalars["ID"];
	tags: Array<GQLTagObjectType>;
	title: Scalars["String"];
	uploadedByUser?: Maybe<GQLUser>;
	url: Scalars["String"];
};

export type GQLEmailBlock = GQLStreamFieldInterface & {
	__typename?: "EmailBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLEmbedBlock = GQLStreamFieldInterface & {
	__typename?: "EmbedBlock";
	blockType: Scalars["String"];
	embed?: Maybe<Scalars["String"]>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawEmbed?: Maybe<Scalars["JSONString"]>;
	rawValue: Scalars["String"];
	url: Scalars["String"];
	value: Scalars["String"];
};

export type GQLErrorType = {
	__typename?: "ErrorType";
	field: Scalars["String"];
	messages: Array<Scalars["String"]>;
};

export type GQLExternalLinkBlock = GQLStreamFieldInterface & {
	__typename?: "ExternalLinkBlock";
	blockType: Scalars["String"];
	blocks: Array<GQLStreamFieldInterface>;
	field: Scalars["String"];
	href: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	text: Scalars["String"];
};

export type GQLFloatBlock = GQLStreamFieldInterface & {
	__typename?: "FloatBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["Float"];
};

export type GQLHomePage = GQLPageInterface & {
	__typename?: "HomePage";
	aliasOf?: Maybe<GQLPage>;
	ancestors: Array<GQLPageInterface>;
	children: Array<GQLPageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<GQLPageInterface>;
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	explainerText?: Maybe<Scalars["String"]>;
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	heroImage?: Maybe<GQLImageObjectType>;
	id?: Maybe<Scalars["ID"]>;
	introText?: Maybe<Scalars["String"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	lockedBy?: Maybe<GQLUser>;
	nextSiblings: Array<GQLPageInterface>;
	numchild: Scalars["Int"];
	owner?: Maybe<GQLUser>;
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<GQLPageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<GQLPageInterface>;
	privacyPage?: Maybe<GQLPageInterface>;
	privacyText?: Maybe<Scalars["String"]>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchImage?: Maybe<GQLImageObjectType>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<GQLPageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type GQLHomePageAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLHomePageChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLHomePageDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLHomePageNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLHomePagePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLHomePageSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLIdeaDashboard = GQLPageInterface & {
	__typename?: "IdeaDashboard";
	aliasOf?: Maybe<GQLPage>;
	ancestors: Array<GQLPageInterface>;
	children: Array<GQLPageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<GQLPageInterface>;
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	id?: Maybe<Scalars["ID"]>;
	intro?: Maybe<Scalars["RichText"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	lockedBy?: Maybe<GQLUser>;
	nextSiblings: Array<GQLPageInterface>;
	numchild: Scalars["Int"];
	owner?: Maybe<GQLUser>;
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<GQLPageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<GQLPageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<GQLPageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type GQLIdeaDashboardAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLIdeaDashboardChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLIdeaDashboardDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLIdeaDashboardNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLIdeaDashboardPreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLIdeaDashboardSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLIdeaProfileScores = {
	__typename?: "IdeaProfileScores";
	ideaScores: Array<Maybe<GQLQuizScore>>;
	profileDescription: Scalars["String"];
	profileOverflowDescription?: Maybe<Scalars["String"]>;
	profileTitle: Scalars["String"];
};

export type GQLIdeaType = {
	__typename?: "IdeaType";
	id: Scalars["ID"];
	owner: GQLUser;
	title: Scalars["String"];
};

export type GQLImageChooserBlock = GQLStreamFieldInterface & {
	__typename?: "ImageChooserBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	image: GQLImageObjectType;
	rawValue: Scalars["String"];
};

export type GQLImageObjectType = {
	__typename?: "ImageObjectType";
	aspectRatio: Scalars["Float"];
	collection: GQLCollectionObjectType;
	createdAt: Scalars["DateTime"];
	file: Scalars["String"];
	fileHash: Scalars["String"];
	fileSize?: Maybe<Scalars["Int"]>;
	focalPointHeight?: Maybe<Scalars["Int"]>;
	focalPointWidth?: Maybe<Scalars["Int"]>;
	focalPointX?: Maybe<Scalars["Int"]>;
	focalPointY?: Maybe<Scalars["Int"]>;
	height: Scalars["Int"];
	id: Scalars["ID"];
	isSvg: Scalars["Boolean"];
	rendition?: Maybe<GQLImageRenditionObjectType>;
	renditions: Array<GQLImageRenditionObjectType>;
	sizes: Scalars["String"];
	/** @deprecated Use the `url` attribute */
	src: Scalars["String"];
	srcSet?: Maybe<Scalars["String"]>;
	tags: Array<GQLTagObjectType>;
	title: Scalars["String"];
	uploadedByUser?: Maybe<GQLUser>;
	url: Scalars["String"];
	width: Scalars["Int"];
};

export type GQLImageObjectTypeRenditionArgs = {
	bgcolor?: InputMaybe<Scalars["String"]>;
	fill?: InputMaybe<Scalars["String"]>;
	format?: InputMaybe<Scalars["String"]>;
	height?: InputMaybe<Scalars["Int"]>;
	jpegquality?: InputMaybe<Scalars["Int"]>;
	max?: InputMaybe<Scalars["String"]>;
	min?: InputMaybe<Scalars["String"]>;
	preserveSvg?: InputMaybe<Scalars["Boolean"]>;
	webpquality?: InputMaybe<Scalars["Int"]>;
	width?: InputMaybe<Scalars["Int"]>;
};

export type GQLImageObjectTypeSrcSetArgs = {
	format?: InputMaybe<Scalars["String"]>;
	preserveSvg?: InputMaybe<Scalars["Boolean"]>;
	sizes?: InputMaybe<Array<InputMaybe<Scalars["Int"]>>>;
};

export type GQLImageRenditionObjectType = {
	__typename?: "ImageRenditionObjectType";
	alt: Scalars["String"];
	backgroundPositionStyle: Scalars["String"];
	file: Scalars["String"];
	filterSpec: Scalars["String"];
	focalPoint?: Maybe<Scalars["String"]>;
	focalPointKey: Scalars["String"];
	height: Scalars["Int"];
	id: Scalars["ID"];
	image: GQLImageObjectType;
	url: Scalars["String"];
	width: Scalars["Int"];
};

export type GQLImageWithCaptionBlock = GQLStreamFieldInterface & {
	__typename?: "ImageWithCaptionBlock";
	blockType: Scalars["String"];
	blocks: Array<GQLStreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

export type GQLIntegerBlock = GQLStreamFieldInterface & {
	__typename?: "IntegerBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["Int"];
};

export type GQLInternalLinkBlock = GQLStreamFieldInterface & {
	__typename?: "InternalLinkBlock";
	blockType: Scalars["String"];
	blocks: Array<GQLStreamFieldInterface>;
	field: Scalars["String"];
	href: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	text: Scalars["String"];
};

export type GQLListBlock = GQLStreamFieldInterface & {
	__typename?: "ListBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	items: Array<GQLStreamFieldInterface>;
	rawValue: Scalars["String"];
};

export type GQLMe = {
	__typename?: "Me";
	firstName?: Maybe<Scalars["String"]>;
	lastName?: Maybe<Scalars["String"]>;
};

export type GQLMenuSettings = {
	__typename?: "MenuSettings";
	id?: Maybe<Scalars["ID"]>;
	menu?: Maybe<Array<Maybe<GQLStreamFieldInterface>>>;
};

export type GQLMutation = {
	__typename?: "Mutation";
	answerQuestion?: Maybe<GQLAnswerMutation>;
	createIdea?: Maybe<GQLCreateIdeaMutation>;
	createUser?: Maybe<GQLCreateUserMutationPayload>;
	refreshToken?: Maybe<GQLRefresh>;
	requestPasswordReset?: Maybe<GQLRequestPasswordReset>;
	resetPasswordConfirm?: Maybe<GQLResetPasswordConfirm>;
	revokeToken?: Maybe<GQLRevoke>;
	/** Obtain JSON Web Token mutation */
	tokenAuth?: Maybe<GQLObtainJsonWebToken>;
	verifyToken?: Maybe<GQLVerify>;
};

export type GQLMutationAnswerQuestionArgs = {
	answer?: InputMaybe<GQLAnswerChoicesEnum>;
	ideaId?: InputMaybe<Scalars["Int"]>;
	questionId?: InputMaybe<Scalars["Int"]>;
};

export type GQLMutationCreateIdeaArgs = {
	title?: InputMaybe<Scalars["String"]>;
};

export type GQLMutationCreateUserArgs = {
	input: GQLCreateUserMutationInput;
};

export type GQLMutationRefreshTokenArgs = {
	refreshToken?: InputMaybe<Scalars["String"]>;
};

export type GQLMutationRequestPasswordResetArgs = {
	email: Scalars["String"];
};

export type GQLMutationResetPasswordConfirmArgs = {
	newPassword: Scalars["String"];
	token: Scalars["String"];
	uidb64: Scalars["String"];
};

export type GQLMutationRevokeTokenArgs = {
	refreshToken?: InputMaybe<Scalars["String"]>;
};

export type GQLMutationTokenAuthArgs = {
	email: Scalars["String"];
	password: Scalars["String"];
};

export type GQLMutationVerifyTokenArgs = {
	token?: InputMaybe<Scalars["String"]>;
};

/** Obtain JSON Web Token mutation */
export type GQLObtainJsonWebToken = {
	__typename?: "ObtainJSONWebToken";
	payload: Scalars["GenericScalar"];
	refreshExpiresIn: Scalars["Int"];
	refreshToken: Scalars["String"];
	token: Scalars["String"];
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type GQLPage = GQLPageInterface & {
	__typename?: "Page";
	aliasOf?: Maybe<GQLPage>;
	aliases: Array<GQLPage>;
	ancestors: Array<GQLPageInterface>;
	children: Array<GQLPageInterface>;
	contentType: Scalars["String"];
	contentpage?: Maybe<GQLContentPage>;
	dashboardpage?: Maybe<GQLDashboardPage>;
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<GQLPageInterface>;
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	homepage?: Maybe<GQLHomePage>;
	id?: Maybe<Scalars["ID"]>;
	ideadashboard?: Maybe<GQLIdeaDashboard>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	lockedBy?: Maybe<GQLUser>;
	nextSiblings: Array<GQLPageInterface>;
	numchild: Scalars["Int"];
	owner?: Maybe<GQLUser>;
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<GQLPageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<GQLPageInterface>;
	profile?: Maybe<GQLProfile>;
	quiz?: Maybe<GQLQuiz>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<GQLPageInterface>;
	sitesRootedHere: Array<GQLSiteObjectType>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type GQLPageAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type GQLPageChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type GQLPageDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type GQLPageNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type GQLPagePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

/**
 * Base Page type used if one isn't generated for the current model.
 * All other node types extend this.
 */
export type GQLPageSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLPageChooserBlock = GQLStreamFieldInterface & {
	__typename?: "PageChooserBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	page: GQLPageInterface;
	rawValue: Scalars["String"];
};

export type GQLPageInterface = {
	ancestors: Array<GQLPageInterface>;
	children: Array<GQLPageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<GQLPageInterface>;
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	id?: Maybe<Scalars["ID"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	nextSiblings: Array<GQLPageInterface>;
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<GQLPageInterface>;
	previousSiblings: Array<GQLPageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<GQLPageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type GQLPageInterfaceAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLPageInterfaceChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLPageInterfaceDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLPageInterfaceNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLPageInterfacePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLPageInterfaceSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLProfile = GQLPageInterface & {
	__typename?: "Profile";
	aliasOf?: Maybe<GQLPage>;
	ancestors: Array<GQLPageInterface>;
	children: Array<GQLPageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<GQLPageInterface>;
	description: Scalars["RichText"];
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	id?: Maybe<Scalars["ID"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	lockedBy?: Maybe<GQLUser>;
	nextSiblings: Array<GQLPageInterface>;
	numchild: Scalars["Int"];
	overflowDescription?: Maybe<Scalars["RichText"]>;
	owner?: Maybe<GQLUser>;
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<GQLPageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<GQLPageInterface>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<GQLPageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
};

export type GQLProfileAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLProfileChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLProfileDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLProfileNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLProfilePreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLProfileSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLProfileObject = {
	__typename?: "ProfileObject";
	id: Scalars["Int"];
	quizProgress?: Maybe<Array<GQLQuizProgress>>;
	scores: Array<Maybe<GQLQuizScore>>;
	slug?: Maybe<Scalars["String"]>;
	title: Scalars["String"];
};

export type GQLQuery = {
	__typename?: "Query";
	collections: Array<Maybe<GQLCollectionObjectType>>;
	document?: Maybe<GQLDocumentObjectType>;
	documentType: Scalars["String"];
	documents: Array<GQLDocumentObjectType>;
	idea?: Maybe<GQLBusinessIdeaType>;
	ideaDashboard?: Maybe<GQLIdeaDashboard>;
	ideaProfileScores?: Maybe<GQLIdeaProfileScores>;
	ideas?: Maybe<Array<Maybe<GQLBusinessIdeaType>>>;
	image?: Maybe<GQLImageObjectType>;
	imageType: Scalars["String"];
	images: Array<GQLImageObjectType>;
	industryOptions: Array<Maybe<GQLSelectOption>>;
	industrySubcategoryOptions: Array<Maybe<GQLSelectOption>>;
	me?: Maybe<GQLMe>;
	menuSettings?: Maybe<GQLMenuSettings>;
	menuSettingss?: Maybe<Array<Maybe<GQLMenuSettings>>>;
	page?: Maybe<GQLPageInterface>;
	pages: Array<GQLPageInterface>;
	questionAnswer?: Maybe<GQLAnswerChoicesEnum>;
	ratingDetails?: Maybe<GQLRatingDetails>;
	redirects: Array<GQLRedirect>;
	search: Array<GQLSearch>;
	setting?: Maybe<GQLSettingsObjectType>;
	settings: Array<GQLSettingsObjectType>;
	site?: Maybe<GQLSiteObjectType>;
	sites: Array<GQLSiteObjectType>;
	tag?: Maybe<GQLTagObjectType>;
	tags: Array<GQLTagObjectType>;
};

export type GQLQueryCollectionsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
};

export type GQLQueryDocumentArgs = {
	id?: InputMaybe<Scalars["ID"]>;
};

export type GQLQueryDocumentsArgs = {
	collection?: InputMaybe<Scalars["ID"]>;
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQueryIdeaArgs = {
	id?: InputMaybe<Scalars["Int"]>;
};

export type GQLQueryIdeaDashboardArgs = {
	order?: InputMaybe<Scalars["String"]>;
	token?: InputMaybe<Scalars["String"]>;
};

export type GQLQueryIdeaProfileScoresArgs = {
	ideaId: Scalars["Int"];
	profileSlug: Scalars["String"];
};

export type GQLQueryImageArgs = {
	id?: InputMaybe<Scalars["ID"]>;
};

export type GQLQueryImagesArgs = {
	collection?: InputMaybe<Scalars["ID"]>;
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQueryIndustrySubcategoryOptionsArgs = {
	industry: Scalars["String"];
};

export type GQLQueryMenuSettingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
};

export type GQLQueryMenuSettingssArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQueryPageArgs = {
	contentType?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	inSite?: InputMaybe<Scalars["Boolean"]>;
	site?: InputMaybe<Scalars["String"]>;
	slug?: InputMaybe<Scalars["String"]>;
	token?: InputMaybe<Scalars["String"]>;
	urlPath?: InputMaybe<Scalars["String"]>;
};

export type GQLQueryPagesArgs = {
	ancestor?: InputMaybe<Scalars["ID"]>;
	contentType?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	inSite?: InputMaybe<Scalars["Boolean"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	parent?: InputMaybe<Scalars["ID"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
	site?: InputMaybe<Scalars["String"]>;
};

export type GQLQueryQuestionAnswerArgs = {
	ideaId?: InputMaybe<Scalars["Int"]>;
	questionId?: InputMaybe<Scalars["Int"]>;
};

export type GQLQueryRatingDetailsArgs = {
	ideaId: Scalars["Int"];
};

export type GQLQuerySearchArgs = {
	query?: InputMaybe<Scalars["String"]>;
};

export type GQLQuerySettingArgs = {
	name?: InputMaybe<Scalars["String"]>;
	site?: InputMaybe<Scalars["String"]>;
};

export type GQLQuerySettingsArgs = {
	name?: InputMaybe<Scalars["String"]>;
	site?: InputMaybe<Scalars["String"]>;
};

export type GQLQuerySiteArgs = {
	hostname?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
};

export type GQLQuerySitesArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQueryTagArgs = {
	id?: InputMaybe<Scalars["ID"]>;
};

export type GQLQueryTagsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
};

export type GQLQuestion = {
	__typename?: "Question";
	answerA: Scalars["String"];
	answerB: Scalars["String"];
	answerC: Scalars["String"];
	answerD: Scalars["String"];
	answerE: Scalars["String"];
	description: Scalars["RichText"];
	id: Scalars["Int"];
	overflowDescription?: Maybe<Scalars["RichText"]>;
	prompt: Scalars["String"];
	score?: Maybe<Scalars["Int"]>;
	subject: Scalars["String"];
};

export type GQLQuiz = GQLPageInterface & {
	__typename?: "Quiz";
	aliasOf?: Maybe<GQLPage>;
	ancestors: Array<GQLPageInterface>;
	children: Array<GQLPageInterface>;
	contentType: Scalars["String"];
	depth?: Maybe<Scalars["Int"]>;
	descendants: Array<GQLPageInterface>;
	draftTitle: Scalars["String"];
	expireAt?: Maybe<Scalars["DateTime"]>;
	expired: Scalars["Boolean"];
	firstPublishedAt?: Maybe<Scalars["DateTime"]>;
	goLiveAt?: Maybe<Scalars["DateTime"]>;
	hasUnpublishedChanges: Scalars["Boolean"];
	id?: Maybe<Scalars["ID"]>;
	intro?: Maybe<Scalars["RichText"]>;
	lastPublishedAt?: Maybe<Scalars["DateTime"]>;
	latestRevisionCreatedAt?: Maybe<Scalars["DateTime"]>;
	live: Scalars["Boolean"];
	locked?: Maybe<Scalars["Boolean"]>;
	lockedAt?: Maybe<Scalars["DateTime"]>;
	lockedBy?: Maybe<GQLUser>;
	nextQuiz?: Maybe<Scalars["String"]>;
	nextSiblings: Array<GQLPageInterface>;
	numchild: Scalars["Int"];
	overflowIntro?: Maybe<Scalars["RichText"]>;
	owner?: Maybe<GQLUser>;
	pageType?: Maybe<Scalars["String"]>;
	parent?: Maybe<GQLPageInterface>;
	path: Scalars["String"];
	previousSiblings: Array<GQLPageInterface>;
	questions: Array<GQLQuestion>;
	searchDescription?: Maybe<Scalars["String"]>;
	searchScore?: Maybe<Scalars["Float"]>;
	seoTitle: Scalars["String"];
	showInMenus: Scalars["Boolean"];
	siblings: Array<GQLPageInterface>;
	slug: Scalars["String"];
	title: Scalars["String"];
	translationKey: Scalars["UUID"];
	url?: Maybe<Scalars["String"]>;
	urlPath: Scalars["String"];
	videoUrl?: Maybe<Scalars["String"]>;
};

export type GQLQuizAncestorsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQuizChildrenArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQuizDescendantsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQuizNextSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQuizPreviousSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQuizQuestionsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQuizSiblingsArgs = {
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLQuizProgress = {
	__typename?: "QuizProgress";
	answeredCount?: Maybe<Scalars["Int"]>;
	completed?: Maybe<Scalars["Boolean"]>;
	id?: Maybe<Scalars["Int"]>;
	questionCount?: Maybe<Scalars["Int"]>;
	slug?: Maybe<Scalars["String"]>;
	started?: Maybe<Scalars["Boolean"]>;
	title?: Maybe<Scalars["String"]>;
};

export type GQLQuizScore = {
	__typename?: "QuizScore";
	questionId?: Maybe<Scalars["Int"]>;
	score?: Maybe<Scalars["Int"]>;
	subject?: Maybe<Scalars["String"]>;
};

export type GQLRatingDetails = {
	__typename?: "RatingDetails";
	description: Scalars["String"];
	intro: Scalars["String"];
	score: Scalars["Int"];
	subtitle: Scalars["String"];
	title: Scalars["String"];
};

export type GQLRawHtmlBlock = GQLStreamFieldInterface & {
	__typename?: "RawHTMLBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLRedirect = {
	__typename?: "Redirect";
	isPermanent: Scalars["Boolean"];
	newUrl?: Maybe<Scalars["String"]>;
	oldPath: Scalars["String"];
	oldUrl: Scalars["String"];
	page?: Maybe<GQLPageInterface>;
	site: GQLSiteObjectType;
};

export type GQLRefresh = {
	__typename?: "Refresh";
	payload: Scalars["GenericScalar"];
	refreshExpiresIn: Scalars["Int"];
	refreshToken: Scalars["String"];
	token: Scalars["String"];
};

export type GQLRegexBlock = GQLStreamFieldInterface & {
	__typename?: "RegexBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLRequestPasswordReset = {
	__typename?: "RequestPasswordReset";
	success?: Maybe<Scalars["Boolean"]>;
};

export type GQLResetPasswordConfirm = {
	__typename?: "ResetPasswordConfirm";
	message?: Maybe<Scalars["String"]>;
	success?: Maybe<Scalars["Boolean"]>;
};

export type GQLRevoke = {
	__typename?: "Revoke";
	revoked: Scalars["Int"];
};

export type GQLRichTextBlock = GQLStreamFieldInterface & {
	__typename?: "RichTextBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLScoresheet = {
	__typename?: "Scoresheet";
	id?: Maybe<Scalars["ID"]>;
};

export type GQLSearch =
	| GQLBusinessIdea
	| GQLContentPage
	| GQLContentSection
	| GQLDashboardPage
	| GQLHomePage
	| GQLIdeaDashboard
	| GQLMenuSettings
	| GQLPage
	| GQLProfile
	| GQLQuestion
	| GQLQuiz
	| GQLScoresheet
	| GQLUser;

export type GQLSelectOption = {
	__typename?: "SelectOption";
	label: Scalars["String"];
	value: Scalars["String"];
};

export type GQLSettingsObjectType = GQLMenuSettings;

export type GQLSidebarLink = {
	__typename?: "SidebarLink";
	children?: Maybe<Array<Maybe<GQLSidebarLink>>>;
	slug?: Maybe<Scalars["String"]>;
	title?: Maybe<Scalars["String"]>;
};

export type GQLSiteObjectType = {
	__typename?: "SiteObjectType";
	hostname: Scalars["String"];
	id: Scalars["ID"];
	/** If true, this site will handle requests for all other hostnames that do not have a site entry of their own */
	isDefaultSite: Scalars["Boolean"];
	menusettings?: Maybe<GQLMenuSettings>;
	page?: Maybe<GQLPageInterface>;
	pages: Array<GQLPageInterface>;
	/** Set this to something other than 80 if you need a specific port number to appear in URLs (e.g. development on port 8000). Does not affect request handling (so port forwarding still works). */
	port: Scalars["Int"];
	rootPage: GQLPage;
	/** Human-readable name for the site. */
	siteName: Scalars["String"];
};

export type GQLSiteObjectTypePageArgs = {
	contentType?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	slug?: InputMaybe<Scalars["String"]>;
	token?: InputMaybe<Scalars["String"]>;
	urlPath?: InputMaybe<Scalars["String"]>;
};

export type GQLSiteObjectTypePagesArgs = {
	contentType?: InputMaybe<Scalars["String"]>;
	id?: InputMaybe<Scalars["ID"]>;
	limit?: InputMaybe<Scalars["PositiveInt"]>;
	offset?: InputMaybe<Scalars["PositiveInt"]>;
	order?: InputMaybe<Scalars["String"]>;
	searchQuery?: InputMaybe<Scalars["String"]>;
};

export type GQLStaticBlock = GQLStreamFieldInterface & {
	__typename?: "StaticBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLStreamBlock = GQLStreamFieldInterface & {
	__typename?: "StreamBlock";
	blockType: Scalars["String"];
	blocks: Array<GQLStreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

export type GQLStreamFieldBlock = GQLStreamFieldInterface & {
	__typename?: "StreamFieldBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLStreamFieldInterface = {
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

export type GQLStructBlock = GQLStreamFieldInterface & {
	__typename?: "StructBlock";
	blockType: Scalars["String"];
	blocks: Array<GQLStreamFieldInterface>;
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
};

export type GQLTagObjectType = {
	__typename?: "TagObjectType";
	id: Scalars["ID"];
	name: Scalars["String"];
};

export type GQLTextBlock = GQLStreamFieldInterface & {
	__typename?: "TextBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLTimeBlock = GQLStreamFieldInterface & {
	__typename?: "TimeBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLTimeBlockValueArgs = {
	format?: InputMaybe<Scalars["String"]>;
};

export type GQLUrlBlock = GQLStreamFieldInterface & {
	__typename?: "URLBlock";
	blockType: Scalars["String"];
	field: Scalars["String"];
	id?: Maybe<Scalars["String"]>;
	rawValue: Scalars["String"];
	value: Scalars["String"];
};

export type GQLUser = {
	__typename?: "User";
	id?: Maybe<Scalars["ID"]>;
};

export type GQLUserType = {
	__typename?: "UserType";
	email: Scalars["String"];
	firstName: Scalars["String"];
	industry?: Maybe<GQLUsersUserIndustryChoices>;
	isBusiness?: Maybe<Scalars["Boolean"]>;
	lastName: Scalars["String"];
};

/** An enumeration. */
export enum GQLUsersUserIndustryChoices {
	/** Agriculture, Forestry and Fishing */
	A = "A",
	/** Mining */
	B = "B",
	/** Manufacturing */
	C = "C",
	/** Electricity, Gas, Water and Waste Services */
	D = "D",
	/** Construction */
	E = "E",
	/** Wholesale Trade */
	F = "F",
	/** Retail Trade */
	G = "G",
	/** Accommodation and Food Services */
	H = "H",
	/** Transport, Postal and Warehousing */
	I = "I",
	/** Information Media and Telecommunications */
	J = "J",
	/** Financial and Insurance Services */
	K = "K",
	/** Rental, Hiring and Real Estate Services */
	L = "L",
	/** Professional, Scientific and Technical Services */
	M = "M",
	/** Administrative and Support Services */
	N = "N",
	/** Public Administration and Safety */
	O = "O",
	/** Education and Training */
	P = "P",
	/** Health Care and Social Assistance */
	Q = "Q",
	/** Arts and Recreation Services */
	R = "R",
	/** Other Services */
	S = "S",
}

export type GQLVerify = {
	__typename?: "Verify";
	payload: Scalars["GenericScalar"];
};

export type GQLAnswerQuestionMutationVariables = Exact<{
	questionId: Scalars["Int"];
	ideaId: Scalars["Int"];
	answer: GQLAnswerChoicesEnum;
}>;

export type GQLAnswerQuestionMutation = {
	__typename?: "Mutation";
	answerQuestion?: { __typename?: "AnswerMutation"; success?: boolean | null } | null;
};

export type GQLCreateNewUserMutationVariables = Exact<{
	input: GQLCreateUserMutationInput;
}>;

export type GQLCreateNewUserMutation = {
	__typename?: "Mutation";
	createUser?: {
		__typename?: "CreateUserMutationPayload";
		errors: Array<{ __typename?: "ErrorType"; field: string; messages: Array<string> }>;
	} | null;
};

export type GQLCreateNewIdeaMutationVariables = Exact<{
	title: Scalars["String"];
}>;

export type GQLCreateNewIdeaMutation = {
	__typename?: "Mutation";
	createIdea?: {
		__typename?: "CreateIdeaMutation";
		success?: boolean | null;
		idea?: { __typename?: "IdeaType"; id: string } | null;
	} | null;
};

export type GQLRequestPasswordResetMutationVariables = Exact<{
	email: Scalars["String"];
}>;

export type GQLRequestPasswordResetMutation = {
	__typename?: "Mutation";
	requestPasswordReset?: { __typename?: "RequestPasswordReset"; success?: boolean | null } | null;
};

export type GQLResetPasswordConfirmMutationVariables = Exact<{
	newPassword: Scalars["String"];
	token: Scalars["String"];
	uidb64: Scalars["String"];
}>;

export type GQLResetPasswordConfirmMutation = {
	__typename?: "Mutation";
	resetPasswordConfirm?: {
		__typename?: "ResetPasswordConfirm";
		success?: boolean | null;
		message?: string | null;
	} | null;
};

export type GQLLoginMutationVariables = Exact<{
	email: Scalars["String"];
	password: Scalars["String"];
}>;

export type GQLLoginMutation = {
	__typename?: "Mutation";
	tokenAuth?: { __typename?: "ObtainJSONWebToken"; token: string; payload: any } | null;
};

export type GQLVerifyTokenMutationVariables = Exact<{
	token: Scalars["String"];
}>;

export type GQLVerifyTokenMutation = {
	__typename?: "Mutation";
	verifyToken?: { __typename?: "Verify"; payload: any } | null;
};

export type GQLRootPageQueryVariables = Exact<{
	hostname: Scalars["String"];
}>;

export type GQLRootPageQuery = {
	__typename?: "Query";
	site?: { __typename?: "SiteObjectType"; rootPage: { __typename?: "Page"; urlPath: string } } | null;
};

export type GQLAllIdeasQueryVariables = Exact<{ [key: string]: never }>;

export type GQLAllIdeasQuery = {
	__typename?: "Query";
	ideas?: Array<{
		__typename?: "BusinessIdeaType";
		id: string;
		title: string;
		rating?: number | null;
		profiles?: Array<{
			__typename?: "ProfileObject";
			quizProgress?: Array<{
				__typename?: "QuizProgress";
				answeredCount?: number | null;
				questionCount?: number | null;
			}> | null;
		}> | null;
	} | null> | null;
};

export type GQLGetIdeaQueryVariables = Exact<{
	id: Scalars["Int"];
}>;

export type GQLGetIdeaQuery = {
	__typename?: "Query";
	idea?: {
		__typename?: "BusinessIdeaType";
		id: string;
		title: string;
		rating?: number | null;
		profiles?: Array<{
			__typename?: "ProfileObject";
			id: number;
			title: string;
			slug?: string | null;
			scores: Array<{
				__typename?: "QuizScore";
				subject?: string | null;
				score?: number | null;
				questionId?: number | null;
			} | null>;
			quizProgress?: Array<{
				__typename?: "QuizProgress";
				id?: number | null;
				slug?: string | null;
				title?: string | null;
				started?: boolean | null;
				completed?: boolean | null;
				answeredCount?: number | null;
				questionCount?: number | null;
			}> | null;
		}> | null;
	} | null;
};

export type GQLGetIdeaProfileScoresQueryVariables = Exact<{
	ideaId: Scalars["Int"];
	profileSlug: Scalars["String"];
}>;

export type GQLGetIdeaProfileScoresQuery = {
	__typename?: "Query";
	ideaProfileScores?: {
		__typename?: "IdeaProfileScores";
		profileTitle: string;
		profileDescription: string;
		profileOverflowDescription?: string | null;
		ideaScores: Array<{
			__typename?: "QuizScore";
			subject?: string | null;
			score?: number | null;
			questionId?: number | null;
		} | null>;
	} | null;
};

export type GQLGetQuizQueryVariables = Exact<{
	slug?: InputMaybe<Scalars["String"]>;
}>;

export type GQLGetQuizQuery = {
	__typename?: "Query";
	page?:
		| {
				__typename?: "ContentPage";
				profileId?:
					| { __typename?: "ContentPage"; id?: string | null; slug: string }
					| { __typename?: "DashboardPage"; id?: string | null; slug: string }
					| { __typename?: "HomePage"; id?: string | null; slug: string }
					| { __typename?: "IdeaDashboard"; id?: string | null; slug: string }
					| { __typename?: "Page"; id?: string | null; slug: string }
					| { __typename?: "Profile"; id?: string | null; slug: string }
					| { __typename?: "Quiz"; id?: string | null; slug: string }
					| null;
		  }
		| {
				__typename?: "DashboardPage";
				profileId?:
					| { __typename?: "ContentPage"; id?: string | null; slug: string }
					| { __typename?: "DashboardPage"; id?: string | null; slug: string }
					| { __typename?: "HomePage"; id?: string | null; slug: string }
					| { __typename?: "IdeaDashboard"; id?: string | null; slug: string }
					| { __typename?: "Page"; id?: string | null; slug: string }
					| { __typename?: "Profile"; id?: string | null; slug: string }
					| { __typename?: "Quiz"; id?: string | null; slug: string }
					| null;
		  }
		| {
				__typename?: "HomePage";
				profileId?:
					| { __typename?: "ContentPage"; id?: string | null; slug: string }
					| { __typename?: "DashboardPage"; id?: string | null; slug: string }
					| { __typename?: "HomePage"; id?: string | null; slug: string }
					| { __typename?: "IdeaDashboard"; id?: string | null; slug: string }
					| { __typename?: "Page"; id?: string | null; slug: string }
					| { __typename?: "Profile"; id?: string | null; slug: string }
					| { __typename?: "Quiz"; id?: string | null; slug: string }
					| null;
		  }
		| {
				__typename?: "IdeaDashboard";
				profileId?:
					| { __typename?: "ContentPage"; id?: string | null; slug: string }
					| { __typename?: "DashboardPage"; id?: string | null; slug: string }
					| { __typename?: "HomePage"; id?: string | null; slug: string }
					| { __typename?: "IdeaDashboard"; id?: string | null; slug: string }
					| { __typename?: "Page"; id?: string | null; slug: string }
					| { __typename?: "Profile"; id?: string | null; slug: string }
					| { __typename?: "Quiz"; id?: string | null; slug: string }
					| null;
		  }
		| {
				__typename?: "Page";
				profileId?:
					| { __typename?: "ContentPage"; id?: string | null; slug: string }
					| { __typename?: "DashboardPage"; id?: string | null; slug: string }
					| { __typename?: "HomePage"; id?: string | null; slug: string }
					| { __typename?: "IdeaDashboard"; id?: string | null; slug: string }
					| { __typename?: "Page"; id?: string | null; slug: string }
					| { __typename?: "Profile"; id?: string | null; slug: string }
					| { __typename?: "Quiz"; id?: string | null; slug: string }
					| null;
		  }
		| {
				__typename?: "Profile";
				profileId?:
					| { __typename?: "ContentPage"; id?: string | null; slug: string }
					| { __typename?: "DashboardPage"; id?: string | null; slug: string }
					| { __typename?: "HomePage"; id?: string | null; slug: string }
					| { __typename?: "IdeaDashboard"; id?: string | null; slug: string }
					| { __typename?: "Page"; id?: string | null; slug: string }
					| { __typename?: "Profile"; id?: string | null; slug: string }
					| { __typename?: "Quiz"; id?: string | null; slug: string }
					| null;
		  }
		| {
				__typename?: "Quiz";
				title: string;
				intro?: any | null;
				videoUrl?: string | null;
				overflowIntro?: any | null;
				nextQuiz?: string | null;
				questions: Array<{
					__typename?: "Question";
					id: number;
					subject: string;
					description: any;
					overflowDescription?: any | null;
					prompt: string;
					answerA: string;
					answerB: string;
					answerC: string;
					answerD: string;
					answerE: string;
				}>;
				profileId?:
					| { __typename?: "ContentPage"; id?: string | null; slug: string }
					| { __typename?: "DashboardPage"; id?: string | null; slug: string }
					| { __typename?: "HomePage"; id?: string | null; slug: string }
					| { __typename?: "IdeaDashboard"; id?: string | null; slug: string }
					| { __typename?: "Page"; id?: string | null; slug: string }
					| { __typename?: "Profile"; id?: string | null; slug: string }
					| { __typename?: "Quiz"; id?: string | null; slug: string }
					| null;
		  }
		| null;
};

export type GQLGetRatingCopyQueryVariables = Exact<{
	ideaId: Scalars["Int"];
}>;

export type GQLGetRatingCopyQuery = {
	__typename?: "Query";
	ratingDetails?: {
		__typename?: "RatingDetails";
		intro: string;
		title: string;
		subtitle: string;
		description: string;
		score: number;
	} | null;
};

export type GQLGetQuestionAnswerQueryVariables = Exact<{
	questionId: Scalars["Int"];
	ideaId: Scalars["Int"];
}>;

export type GQLGetQuestionAnswerQuery = { __typename?: "Query"; questionAnswer?: GQLAnswerChoicesEnum | null };

export type GQLPageQueryVariables = Exact<{
	urlPath?: InputMaybe<Scalars["String"]>;
	previewToken?: InputMaybe<Scalars["String"]>;
	contentType?: InputMaybe<Scalars["String"]>;
}>;

export type GQLPageQuery = {
	__typename?: "Query";
	page?:
		| {
				__typename: "ContentPage";
				title: string;
				seoTitle: string;
				searchDescription?: string | null;
				searchImage?: { __typename?: "ImageObjectType"; url: string; width: number; height: number } | null;
				sidebar?: Array<{
					__typename?: "SidebarLink";
					title?: string | null;
					slug?: string | null;
					children?: Array<{ __typename?: "SidebarLink"; title?: string | null; slug?: string | null } | null> | null;
				} | null> | null;
				sections?: Array<{
					__typename?: "ContentSection";
					id?: string | null;
					title?: string | null;
					slug?: string | null;
					content?: Array<
						| { __typename?: "BlockQuoteBlock"; blockType: string }
						| { __typename?: "BooleanBlock"; blockType: string }
						| { __typename?: "CharBlock"; blockType: string; id?: string | null; value: string }
						| { __typename?: "ChoiceBlock"; blockType: string }
						| { __typename?: "DateBlock"; blockType: string }
						| { __typename?: "DateTimeBlock"; blockType: string }
						| { __typename?: "DecimalBlock"; blockType: string }
						| { __typename?: "DocumentChooserBlock"; blockType: string }
						| { __typename?: "EmailBlock"; blockType: string }
						| { __typename?: "EmbedBlock"; blockType: string }
						| { __typename?: "ExternalLinkBlock"; blockType: string }
						| { __typename?: "FloatBlock"; blockType: string }
						| { __typename?: "ImageChooserBlock"; blockType: string }
						| {
								__typename?: "ImageWithCaptionBlock";
								blockType: string;
								blocks: Array<
									| { __typename?: "BlockQuoteBlock"; field: string; rawValue: string }
									| { __typename?: "BooleanBlock"; field: string; rawValue: string }
									| { __typename?: "CharBlock"; field: string; rawValue: string }
									| { __typename?: "ChoiceBlock"; field: string; rawValue: string }
									| { __typename?: "DateBlock"; field: string; rawValue: string }
									| { __typename?: "DateTimeBlock"; field: string; rawValue: string }
									| { __typename?: "DecimalBlock"; field: string; rawValue: string }
									| { __typename?: "DocumentChooserBlock"; field: string; rawValue: string }
									| { __typename?: "EmailBlock"; field: string; rawValue: string }
									| { __typename?: "EmbedBlock"; field: string; rawValue: string }
									| { __typename?: "ExternalLinkBlock"; field: string; rawValue: string }
									| { __typename?: "FloatBlock"; field: string; rawValue: string }
									| {
											__typename?: "ImageChooserBlock";
											field: string;
											rawValue: string;
											image: {
												__typename?: "ImageObjectType";
												rendition?: {
													__typename?: "ImageRenditionObjectType";
													url: string;
													width: number;
													height: number;
													image: { __typename?: "ImageObjectType"; title: string };
												} | null;
											};
									  }
									| { __typename?: "ImageWithCaptionBlock"; field: string; rawValue: string }
									| { __typename?: "IntegerBlock"; field: string; rawValue: string }
									| { __typename?: "InternalLinkBlock"; field: string; rawValue: string }
									| { __typename?: "ListBlock"; field: string; rawValue: string }
									| { __typename?: "PageChooserBlock"; field: string; rawValue: string }
									| { __typename?: "RawHTMLBlock"; field: string; rawValue: string }
									| { __typename?: "RegexBlock"; field: string; rawValue: string }
									| { __typename?: "RichTextBlock"; field: string; rawValue: string }
									| { __typename?: "StaticBlock"; field: string; rawValue: string }
									| { __typename?: "StreamBlock"; field: string; rawValue: string }
									| { __typename?: "StreamFieldBlock"; field: string; rawValue: string }
									| { __typename?: "StructBlock"; field: string; rawValue: string }
									| { __typename?: "TextBlock"; field: string; rawValue: string }
									| { __typename?: "TimeBlock"; field: string; rawValue: string }
									| { __typename?: "URLBlock"; field: string; rawValue: string }
								>;
						  }
						| { __typename?: "IntegerBlock"; blockType: string }
						| { __typename?: "InternalLinkBlock"; blockType: string }
						| { __typename?: "ListBlock"; blockType: string }
						| { __typename?: "PageChooserBlock"; blockType: string }
						| { __typename?: "RawHTMLBlock"; blockType: string }
						| { __typename?: "RegexBlock"; blockType: string }
						| { __typename?: "RichTextBlock"; blockType: string; id?: string | null; value: string }
						| { __typename?: "StaticBlock"; blockType: string }
						| { __typename?: "StreamBlock"; blockType: string }
						| { __typename?: "StreamFieldBlock"; blockType: string }
						| { __typename?: "StructBlock"; blockType: string }
						| { __typename?: "TextBlock"; blockType: string }
						| { __typename?: "TimeBlock"; blockType: string }
						| { __typename?: "URLBlock"; blockType: string }
						| null
					> | null;
				} | null> | null;
		  }
		| {
				__typename: "DashboardPage";
				title: string;
				seoTitle: string;
				searchDescription?: string | null;
				emptyHelpText?: any | null;
				generalHelpText?: any | null;
		  }
		| {
				__typename: "HomePage";
				title: string;
				seoTitle: string;
				searchDescription?: string | null;
				introText?: string | null;
				explainerText?: string | null;
				privacyText?: string | null;
				searchImage?: { __typename?: "ImageObjectType"; url: string; width: number; height: number } | null;
				heroImage?: {
					__typename?: "ImageObjectType";
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				} | null;
				privacyPage?:
					| { __typename?: "ContentPage"; urlPath: string }
					| { __typename?: "DashboardPage"; urlPath: string }
					| { __typename?: "HomePage"; urlPath: string }
					| { __typename?: "IdeaDashboard"; urlPath: string }
					| { __typename?: "Page"; urlPath: string }
					| { __typename?: "Profile"; urlPath: string }
					| { __typename?: "Quiz"; urlPath: string }
					| null;
		  }
		| {
				__typename: "IdeaDashboard";
				title: string;
				seoTitle: string;
				searchDescription?: string | null;
				intro?: any | null;
		  }
		| { __typename: "Page"; title: string; seoTitle: string; searchDescription?: string | null }
		| {
				__typename: "Profile";
				title: string;
				seoTitle: string;
				searchDescription?: string | null;
				description: any;
				overflowDescription?: any | null;
				slug: string;
		  }
		| {
				__typename: "Quiz";
				title: string;
				seoTitle: string;
				searchDescription?: string | null;
				slug: string;
				intro?: any | null;
				videoUrl?: string | null;
				overflowIntro?: any | null;
				nextQuiz?: string | null;
				questions: Array<{
					__typename?: "Question";
					id: number;
					subject: string;
					description: any;
					overflowDescription?: any | null;
					prompt: string;
					answerA: string;
					answerB: string;
					answerC: string;
					answerD: string;
					answerE: string;
				}>;
				profileId?:
					| { __typename?: "ContentPage"; id?: string | null; slug: string }
					| { __typename?: "DashboardPage"; id?: string | null; slug: string }
					| { __typename?: "HomePage"; id?: string | null; slug: string }
					| { __typename?: "IdeaDashboard"; id?: string | null; slug: string }
					| { __typename?: "Page"; id?: string | null; slug: string }
					| { __typename?: "Profile"; id?: string | null; slug: string }
					| { __typename?: "Quiz"; id?: string | null; slug: string }
					| null;
		  }
		| null;
};

export type GQLDashboardPageFragment = {
	__typename?: "DashboardPage";
	emptyHelpText?: any | null;
	generalHelpText?: any | null;
};

export type GQLProfileFragment = {
	__typename?: "Profile";
	title: string;
	description: any;
	overflowDescription?: any | null;
	slug: string;
};

export type GQLIdeaDashboardFragment = { __typename?: "IdeaDashboard"; intro?: any | null };

export type GQLContentPageFragment = {
	__typename?: "ContentPage";
	searchImage?: { __typename?: "ImageObjectType"; url: string; width: number; height: number } | null;
	sidebar?: Array<{
		__typename?: "SidebarLink";
		title?: string | null;
		slug?: string | null;
		children?: Array<{ __typename?: "SidebarLink"; title?: string | null; slug?: string | null } | null> | null;
	} | null> | null;
	sections?: Array<{
		__typename?: "ContentSection";
		id?: string | null;
		title?: string | null;
		slug?: string | null;
		content?: Array<
			| { __typename?: "BlockQuoteBlock"; blockType: string }
			| { __typename?: "BooleanBlock"; blockType: string }
			| { __typename?: "CharBlock"; blockType: string; id?: string | null; value: string }
			| { __typename?: "ChoiceBlock"; blockType: string }
			| { __typename?: "DateBlock"; blockType: string }
			| { __typename?: "DateTimeBlock"; blockType: string }
			| { __typename?: "DecimalBlock"; blockType: string }
			| { __typename?: "DocumentChooserBlock"; blockType: string }
			| { __typename?: "EmailBlock"; blockType: string }
			| { __typename?: "EmbedBlock"; blockType: string }
			| { __typename?: "ExternalLinkBlock"; blockType: string }
			| { __typename?: "FloatBlock"; blockType: string }
			| { __typename?: "ImageChooserBlock"; blockType: string }
			| {
					__typename?: "ImageWithCaptionBlock";
					blockType: string;
					blocks: Array<
						| { __typename?: "BlockQuoteBlock"; field: string; rawValue: string }
						| { __typename?: "BooleanBlock"; field: string; rawValue: string }
						| { __typename?: "CharBlock"; field: string; rawValue: string }
						| { __typename?: "ChoiceBlock"; field: string; rawValue: string }
						| { __typename?: "DateBlock"; field: string; rawValue: string }
						| { __typename?: "DateTimeBlock"; field: string; rawValue: string }
						| { __typename?: "DecimalBlock"; field: string; rawValue: string }
						| { __typename?: "DocumentChooserBlock"; field: string; rawValue: string }
						| { __typename?: "EmailBlock"; field: string; rawValue: string }
						| { __typename?: "EmbedBlock"; field: string; rawValue: string }
						| { __typename?: "ExternalLinkBlock"; field: string; rawValue: string }
						| { __typename?: "FloatBlock"; field: string; rawValue: string }
						| {
								__typename?: "ImageChooserBlock";
								field: string;
								rawValue: string;
								image: {
									__typename?: "ImageObjectType";
									rendition?: {
										__typename?: "ImageRenditionObjectType";
										url: string;
										width: number;
										height: number;
										image: { __typename?: "ImageObjectType"; title: string };
									} | null;
								};
						  }
						| { __typename?: "ImageWithCaptionBlock"; field: string; rawValue: string }
						| { __typename?: "IntegerBlock"; field: string; rawValue: string }
						| { __typename?: "InternalLinkBlock"; field: string; rawValue: string }
						| { __typename?: "ListBlock"; field: string; rawValue: string }
						| { __typename?: "PageChooserBlock"; field: string; rawValue: string }
						| { __typename?: "RawHTMLBlock"; field: string; rawValue: string }
						| { __typename?: "RegexBlock"; field: string; rawValue: string }
						| { __typename?: "RichTextBlock"; field: string; rawValue: string }
						| { __typename?: "StaticBlock"; field: string; rawValue: string }
						| { __typename?: "StreamBlock"; field: string; rawValue: string }
						| { __typename?: "StreamFieldBlock"; field: string; rawValue: string }
						| { __typename?: "StructBlock"; field: string; rawValue: string }
						| { __typename?: "TextBlock"; field: string; rawValue: string }
						| { __typename?: "TimeBlock"; field: string; rawValue: string }
						| { __typename?: "URLBlock"; field: string; rawValue: string }
					>;
			  }
			| { __typename?: "IntegerBlock"; blockType: string }
			| { __typename?: "InternalLinkBlock"; blockType: string }
			| { __typename?: "ListBlock"; blockType: string }
			| { __typename?: "PageChooserBlock"; blockType: string }
			| { __typename?: "RawHTMLBlock"; blockType: string }
			| { __typename?: "RegexBlock"; blockType: string }
			| { __typename?: "RichTextBlock"; blockType: string; id?: string | null; value: string }
			| { __typename?: "StaticBlock"; blockType: string }
			| { __typename?: "StreamBlock"; blockType: string }
			| { __typename?: "StreamFieldBlock"; blockType: string }
			| { __typename?: "StructBlock"; blockType: string }
			| { __typename?: "TextBlock"; blockType: string }
			| { __typename?: "TimeBlock"; blockType: string }
			| { __typename?: "URLBlock"; blockType: string }
			| null
		> | null;
	} | null> | null;
};

export type GQLQuizFragment = {
	__typename?: "Quiz";
	slug: string;
	title: string;
	intro?: any | null;
	videoUrl?: string | null;
	overflowIntro?: any | null;
	nextQuiz?: string | null;
	questions: Array<{
		__typename?: "Question";
		id: number;
		subject: string;
		description: any;
		overflowDescription?: any | null;
		prompt: string;
		answerA: string;
		answerB: string;
		answerC: string;
		answerD: string;
		answerE: string;
	}>;
	profileId?:
		| { __typename?: "ContentPage"; id?: string | null; slug: string }
		| { __typename?: "DashboardPage"; id?: string | null; slug: string }
		| { __typename?: "HomePage"; id?: string | null; slug: string }
		| { __typename?: "IdeaDashboard"; id?: string | null; slug: string }
		| { __typename?: "Page"; id?: string | null; slug: string }
		| { __typename?: "Profile"; id?: string | null; slug: string }
		| { __typename?: "Quiz"; id?: string | null; slug: string }
		| null;
};

export type GQLRichTextFragment = { __typename?: "RichTextBlock"; id?: string | null; value: string };

export type GQLHeadingFragment = { __typename?: "CharBlock"; id?: string | null; value: string };

export type GQLImageWithCaptionFragment = {
	__typename?: "ImageWithCaptionBlock";
	blocks: Array<
		| { __typename?: "BlockQuoteBlock"; field: string; rawValue: string }
		| { __typename?: "BooleanBlock"; field: string; rawValue: string }
		| { __typename?: "CharBlock"; field: string; rawValue: string }
		| { __typename?: "ChoiceBlock"; field: string; rawValue: string }
		| { __typename?: "DateBlock"; field: string; rawValue: string }
		| { __typename?: "DateTimeBlock"; field: string; rawValue: string }
		| { __typename?: "DecimalBlock"; field: string; rawValue: string }
		| { __typename?: "DocumentChooserBlock"; field: string; rawValue: string }
		| { __typename?: "EmailBlock"; field: string; rawValue: string }
		| { __typename?: "EmbedBlock"; field: string; rawValue: string }
		| { __typename?: "ExternalLinkBlock"; field: string; rawValue: string }
		| { __typename?: "FloatBlock"; field: string; rawValue: string }
		| {
				__typename?: "ImageChooserBlock";
				field: string;
				rawValue: string;
				image: {
					__typename?: "ImageObjectType";
					rendition?: {
						__typename?: "ImageRenditionObjectType";
						url: string;
						width: number;
						height: number;
						image: { __typename?: "ImageObjectType"; title: string };
					} | null;
				};
		  }
		| { __typename?: "ImageWithCaptionBlock"; field: string; rawValue: string }
		| { __typename?: "IntegerBlock"; field: string; rawValue: string }
		| { __typename?: "InternalLinkBlock"; field: string; rawValue: string }
		| { __typename?: "ListBlock"; field: string; rawValue: string }
		| { __typename?: "PageChooserBlock"; field: string; rawValue: string }
		| { __typename?: "RawHTMLBlock"; field: string; rawValue: string }
		| { __typename?: "RegexBlock"; field: string; rawValue: string }
		| { __typename?: "RichTextBlock"; field: string; rawValue: string }
		| { __typename?: "StaticBlock"; field: string; rawValue: string }
		| { __typename?: "StreamBlock"; field: string; rawValue: string }
		| { __typename?: "StreamFieldBlock"; field: string; rawValue: string }
		| { __typename?: "StructBlock"; field: string; rawValue: string }
		| { __typename?: "TextBlock"; field: string; rawValue: string }
		| { __typename?: "TimeBlock"; field: string; rawValue: string }
		| { __typename?: "URLBlock"; field: string; rawValue: string }
	>;
};

export type GQLImageRenditionFieldsFragment = {
	__typename?: "ImageRenditionObjectType";
	url: string;
	width: number;
	height: number;
	image: { __typename?: "ImageObjectType"; title: string };
};

export type GQLHomePageFragment = {
	__typename?: "HomePage";
	introText?: string | null;
	explainerText?: string | null;
	privacyText?: string | null;
	searchImage?: { __typename?: "ImageObjectType"; url: string; width: number; height: number } | null;
	heroImage?: {
		__typename?: "ImageObjectType";
		rendition?: {
			__typename?: "ImageRenditionObjectType";
			url: string;
			width: number;
			height: number;
			image: { __typename?: "ImageObjectType"; title: string };
		} | null;
	} | null;
	privacyPage?:
		| { __typename?: "ContentPage"; urlPath: string }
		| { __typename?: "DashboardPage"; urlPath: string }
		| { __typename?: "HomePage"; urlPath: string }
		| { __typename?: "IdeaDashboard"; urlPath: string }
		| { __typename?: "Page"; urlPath: string }
		| { __typename?: "Profile"; urlPath: string }
		| { __typename?: "Quiz"; urlPath: string }
		| null;
};

export type GQLAllPagesQueryVariables = Exact<{
	contentTypes?: InputMaybe<Scalars["String"]>;
}>;

export type GQLAllPagesQuery = {
	__typename?: "Query";
	pages: Array<
		| { __typename?: "ContentPage"; slug: string; title: string; id?: string | null; live: boolean; urlPath: string }
		| { __typename?: "DashboardPage"; slug: string; title: string; id?: string | null; live: boolean; urlPath: string }
		| { __typename?: "HomePage"; slug: string; title: string; id?: string | null; live: boolean; urlPath: string }
		| { __typename?: "IdeaDashboard"; slug: string; title: string; id?: string | null; live: boolean; urlPath: string }
		| { __typename?: "Page"; slug: string; title: string; id?: string | null; live: boolean; urlPath: string }
		| { __typename?: "Profile"; slug: string; title: string; id?: string | null; live: boolean; urlPath: string }
		| { __typename?: "Quiz"; slug: string; title: string; id?: string | null; live: boolean; urlPath: string }
	>;
};

export type GQLGetMenuQueryVariables = Exact<{ [key: string]: never }>;

export type GQLGetMenuQuery = {
	__typename?: "Query";
	setting?: {
		__typename?: "MenuSettings";
		menu?: Array<
			| { __typename?: "BlockQuoteBlock"; blockType: string }
			| { __typename?: "BooleanBlock"; blockType: string }
			| { __typename?: "CharBlock"; blockType: string }
			| { __typename?: "ChoiceBlock"; blockType: string }
			| { __typename?: "DateBlock"; blockType: string }
			| { __typename?: "DateTimeBlock"; blockType: string }
			| { __typename?: "DecimalBlock"; blockType: string }
			| { __typename?: "DocumentChooserBlock"; blockType: string }
			| { __typename?: "EmailBlock"; blockType: string }
			| { __typename?: "EmbedBlock"; blockType: string }
			| { __typename?: "ExternalLinkBlock"; blockType: string; id?: string | null; href: string; text: string }
			| { __typename?: "FloatBlock"; blockType: string }
			| { __typename?: "ImageChooserBlock"; blockType: string }
			| { __typename?: "ImageWithCaptionBlock"; blockType: string }
			| { __typename?: "IntegerBlock"; blockType: string }
			| { __typename?: "InternalLinkBlock"; blockType: string; id?: string | null; href: string; text: string }
			| { __typename?: "ListBlock"; blockType: string }
			| { __typename?: "PageChooserBlock"; blockType: string }
			| { __typename?: "RawHTMLBlock"; blockType: string }
			| { __typename?: "RegexBlock"; blockType: string }
			| { __typename?: "RichTextBlock"; blockType: string }
			| { __typename?: "StaticBlock"; blockType: string }
			| { __typename?: "StreamBlock"; blockType: string }
			| { __typename?: "StreamFieldBlock"; blockType: string }
			| { __typename?: "StructBlock"; blockType: string }
			| { __typename?: "TextBlock"; blockType: string }
			| { __typename?: "TimeBlock"; blockType: string }
			| { __typename?: "URLBlock"; blockType: string }
			| null
		> | null;
	} | null;
};

export type GQLGetDashboardSlugQueryVariables = Exact<{ [key: string]: never }>;

export type GQLGetDashboardSlugQuery = {
	__typename?: "Query";
	pages: Array<
		| { __typename?: "ContentPage"; slug: string }
		| { __typename?: "DashboardPage"; slug: string }
		| { __typename?: "HomePage"; slug: string }
		| { __typename?: "IdeaDashboard"; slug: string }
		| { __typename?: "Page"; slug: string }
		| { __typename?: "Profile"; slug: string }
		| { __typename?: "Quiz"; slug: string }
	>;
};

export type GQLInternalFragment = { __typename?: "InternalLinkBlock"; id?: string | null; href: string; text: string };

export type GQLExternalFragment = { __typename?: "ExternalLinkBlock"; id?: string | null; href: string; text: string };

export type GQLGetIdeaLandingContentQueryVariables = Exact<{ [key: string]: never }>;

export type GQLGetIdeaLandingContentQuery = {
	__typename?: "Query";
	ideaDashboard?: { __typename?: "IdeaDashboard"; intro?: any | null } | null;
};

export type GQLGetMeQueryVariables = Exact<{ [key: string]: never }>;

export type GQLGetMeQuery = {
	__typename?: "Query";
	me?: { __typename?: "Me"; firstName?: string | null; lastName?: string | null } | null;
};

export type GQLGetIndustryOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GQLGetIndustryOptionsQuery = {
	__typename?: "Query";
	industryOptions: Array<{ __typename?: "SelectOption"; value: string; label: string } | null>;
};

export type GQLGetIndustrySubcategoryOptionsQueryVariables = Exact<{
	industry: Scalars["String"];
}>;

export type GQLGetIndustrySubcategoryOptionsQuery = {
	__typename?: "Query";
	industrySubcategoryOptions: Array<{ __typename?: "SelectOption"; value: string; label: string } | null>;
};

export const DashboardPageFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "DashboardPage" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DashboardPage" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "emptyHelpText" } },
					{ kind: "Field", name: { kind: "Name", value: "generalHelpText" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GQLDashboardPageFragment, unknown>;
export const ProfileFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "Profile" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "title" } },
					{ kind: "Field", name: { kind: "Name", value: "description" } },
					{ kind: "Field", name: { kind: "Name", value: "overflowDescription" } },
					{ kind: "Field", name: { kind: "Name", value: "slug" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GQLProfileFragment, unknown>;
export const IdeaDashboardFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "IdeaDashboard" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IdeaDashboard" } },
			selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "intro" } }] },
		},
	],
} as unknown as DocumentNode<GQLIdeaDashboardFragment, unknown>;
export const RichTextFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "richText" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RichTextBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "value" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GQLRichTextFragment, unknown>;
export const ImageRenditionFieldsFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "imageRenditionFields" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageRenditionObjectType" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "url" } },
					{ kind: "Field", name: { kind: "Name", value: "width" } },
					{ kind: "Field", name: { kind: "Name", value: "height" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "image" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLImageRenditionFieldsFragment, unknown>;
export const ImageWithCaptionFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "imageWithCaption" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageWithCaptionBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "blocks" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "field" } },
								{ kind: "Field", name: { kind: "Name", value: "rawValue" } },
								{
									kind: "InlineFragment",
									typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageChooserBlock" } },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "image" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "rendition" },
															arguments: [
																{
																	kind: "Argument",
																	name: { kind: "Name", value: "fill" },
																	value: { kind: "StringValue", value: "1400x840", block: false },
																},
															],
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{ kind: "FragmentSpread", name: { kind: "Name", value: "imageRenditionFields" } },
																],
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "imageRenditionFields" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageRenditionObjectType" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "url" } },
					{ kind: "Field", name: { kind: "Name", value: "width" } },
					{ kind: "Field", name: { kind: "Name", value: "height" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "image" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLImageWithCaptionFragment, unknown>;
export const HeadingFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "heading" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CharBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "value" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GQLHeadingFragment, unknown>;
export const ContentPageFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "ContentPage" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContentPage" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "searchImage" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "url" } },
								{ kind: "Field", name: { kind: "Name", value: "width" } },
								{ kind: "Field", name: { kind: "Name", value: "height" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "sidebar" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "title" } },
								{ kind: "Field", name: { kind: "Name", value: "slug" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "children" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "title" } },
											{ kind: "Field", name: { kind: "Name", value: "slug" } },
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "sections" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "title" } },
								{ kind: "Field", name: { kind: "Name", value: "slug" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "content" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "blockType" } },
											{ kind: "FragmentSpread", name: { kind: "Name", value: "richText" } },
											{ kind: "FragmentSpread", name: { kind: "Name", value: "imageWithCaption" } },
											{ kind: "FragmentSpread", name: { kind: "Name", value: "heading" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "imageRenditionFields" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageRenditionObjectType" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "url" } },
					{ kind: "Field", name: { kind: "Name", value: "width" } },
					{ kind: "Field", name: { kind: "Name", value: "height" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "image" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "richText" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RichTextBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "value" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "imageWithCaption" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageWithCaptionBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "blocks" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "field" } },
								{ kind: "Field", name: { kind: "Name", value: "rawValue" } },
								{
									kind: "InlineFragment",
									typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageChooserBlock" } },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "image" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "rendition" },
															arguments: [
																{
																	kind: "Argument",
																	name: { kind: "Name", value: "fill" },
																	value: { kind: "StringValue", value: "1400x840", block: false },
																},
															],
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{ kind: "FragmentSpread", name: { kind: "Name", value: "imageRenditionFields" } },
																],
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "heading" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CharBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "value" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GQLContentPageFragment, unknown>;
export const QuizFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "Quiz" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quiz" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "slug" } },
					{ kind: "Field", name: { kind: "Name", value: "title" } },
					{ kind: "Field", name: { kind: "Name", value: "intro" } },
					{ kind: "Field", name: { kind: "Name", value: "videoUrl" } },
					{ kind: "Field", name: { kind: "Name", value: "overflowIntro" } },
					{ kind: "Field", name: { kind: "Name", value: "nextQuiz" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "questions" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "subject" } },
								{ kind: "Field", name: { kind: "Name", value: "description" } },
								{ kind: "Field", name: { kind: "Name", value: "overflowDescription" } },
								{ kind: "Field", name: { kind: "Name", value: "prompt" } },
								{ kind: "Field", name: { kind: "Name", value: "answerA" } },
								{ kind: "Field", name: { kind: "Name", value: "answerB" } },
								{ kind: "Field", name: { kind: "Name", value: "answerC" } },
								{ kind: "Field", name: { kind: "Name", value: "answerD" } },
								{ kind: "Field", name: { kind: "Name", value: "answerE" } },
							],
						},
					},
					{
						kind: "Field",
						alias: { kind: "Name", value: "profileId" },
						name: { kind: "Name", value: "parent" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "slug" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLQuizFragment, unknown>;
export const HomePageFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "HomePage" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HomePage" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "searchImage" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "url" } },
								{ kind: "Field", name: { kind: "Name", value: "width" } },
								{ kind: "Field", name: { kind: "Name", value: "height" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "introText" } },
					{ kind: "Field", name: { kind: "Name", value: "explainerText" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "heroImage" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "rendition" },
									arguments: [
										{
											kind: "Argument",
											name: { kind: "Name", value: "fill" },
											value: { kind: "StringValue", value: "988x602", block: false },
										},
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "imageRenditionFields" } }],
									},
								},
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "privacyText" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "privacyPage" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "urlPath" } }],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "imageRenditionFields" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageRenditionObjectType" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "url" } },
					{ kind: "Field", name: { kind: "Name", value: "width" } },
					{ kind: "Field", name: { kind: "Name", value: "height" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "image" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLHomePageFragment, unknown>;
export const InternalFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "Internal" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "InternalLinkBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "href" } },
					{ kind: "Field", name: { kind: "Name", value: "text" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GQLInternalFragment, unknown>;
export const ExternalFragmentDoc = {
	kind: "Document",
	definitions: [
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "External" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ExternalLinkBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "href" } },
					{ kind: "Field", name: { kind: "Name", value: "text" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GQLExternalFragment, unknown>;
export const AnswerQuestionDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "answerQuestion" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "questionId" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
				},
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "ideaId" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
				},
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "answer" } },
					type: {
						kind: "NonNullType",
						type: { kind: "NamedType", name: { kind: "Name", value: "AnswerChoicesEnum" } },
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "answerQuestion" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "questionId" },
								value: { kind: "Variable", name: { kind: "Name", value: "questionId" } },
							},
							{
								kind: "Argument",
								name: { kind: "Name", value: "ideaId" },
								value: { kind: "Variable", name: { kind: "Name", value: "ideaId" } },
							},
							{
								kind: "Argument",
								name: { kind: "Name", value: "answer" },
								value: { kind: "Variable", name: { kind: "Name", value: "answer" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLAnswerQuestionMutation, GQLAnswerQuestionMutationVariables>;
export const CreateNewUserDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "createNewUser" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
					type: {
						kind: "NonNullType",
						type: { kind: "NamedType", name: { kind: "Name", value: "CreateUserMutationInput" } },
					},
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createUser" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "input" },
								value: { kind: "Variable", name: { kind: "Name", value: "input" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "errors" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "field" } },
											{ kind: "Field", name: { kind: "Name", value: "messages" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLCreateNewUserMutation, GQLCreateNewUserMutationVariables>;
export const CreateNewIdeaDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "createNewIdea" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "title" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "createIdea" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "title" },
								value: { kind: "Variable", name: { kind: "Name", value: "title" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "success" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "idea" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLCreateNewIdeaMutation, GQLCreateNewIdeaMutationVariables>;
export const RequestPasswordResetDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "requestPasswordReset" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "requestPasswordReset" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "email" },
								value: { kind: "Variable", name: { kind: "Name", value: "email" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLRequestPasswordResetMutation, GQLRequestPasswordResetMutationVariables>;
export const ResetPasswordConfirmDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "resetPasswordConfirm" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "newPassword" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "uidb64" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "resetPasswordConfirm" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "newPassword" },
								value: { kind: "Variable", name: { kind: "Name", value: "newPassword" } },
							},
							{
								kind: "Argument",
								name: { kind: "Name", value: "token" },
								value: { kind: "Variable", name: { kind: "Name", value: "token" } },
							},
							{
								kind: "Argument",
								name: { kind: "Name", value: "uidb64" },
								value: { kind: "Variable", name: { kind: "Name", value: "uidb64" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "success" } },
								{ kind: "Field", name: { kind: "Name", value: "message" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLResetPasswordConfirmMutation, GQLResetPasswordConfirmMutationVariables>;
export const LoginDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "login" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "email" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "password" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "tokenAuth" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "email" },
								value: { kind: "Variable", name: { kind: "Name", value: "email" } },
							},
							{
								kind: "Argument",
								name: { kind: "Name", value: "password" },
								value: { kind: "Variable", name: { kind: "Name", value: "password" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "token" } },
								{ kind: "Field", name: { kind: "Name", value: "payload" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLLoginMutation, GQLLoginMutationVariables>;
export const VerifyTokenDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "mutation",
			name: { kind: "Name", value: "verifyToken" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "token" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "verifyToken" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "token" },
								value: { kind: "Variable", name: { kind: "Name", value: "token" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "payload" } }],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLVerifyTokenMutation, GQLVerifyTokenMutationVariables>;
export const RootPageDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "rootPage" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "hostname" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "site" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "hostname" },
								value: { kind: "Variable", name: { kind: "Name", value: "hostname" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "rootPage" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [{ kind: "Field", name: { kind: "Name", value: "urlPath" } }],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLRootPageQuery, GQLRootPageQueryVariables>;
export const AllIdeasDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "allIdeas" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "ideas" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "title" } },
								{ kind: "Field", name: { kind: "Name", value: "rating" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "profiles" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "quizProgress" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{ kind: "Field", name: { kind: "Name", value: "answeredCount" } },
														{ kind: "Field", name: { kind: "Name", value: "questionCount" } },
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLAllIdeasQuery, GQLAllIdeasQueryVariables>;
export const GetIdeaDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getIdea" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "idea" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "id" },
								value: { kind: "Variable", name: { kind: "Name", value: "id" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "title" } },
								{ kind: "Field", name: { kind: "Name", value: "rating" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "profiles" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "title" } },
											{ kind: "Field", name: { kind: "Name", value: "slug" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "scores" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{ kind: "Field", name: { kind: "Name", value: "subject" } },
														{ kind: "Field", name: { kind: "Name", value: "score" } },
														{ kind: "Field", name: { kind: "Name", value: "questionId" } },
													],
												},
											},
											{
												kind: "Field",
												name: { kind: "Name", value: "quizProgress" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{ kind: "Field", name: { kind: "Name", value: "id" } },
														{ kind: "Field", name: { kind: "Name", value: "slug" } },
														{ kind: "Field", name: { kind: "Name", value: "title" } },
														{ kind: "Field", name: { kind: "Name", value: "started" } },
														{ kind: "Field", name: { kind: "Name", value: "completed" } },
														{ kind: "Field", name: { kind: "Name", value: "answeredCount" } },
														{ kind: "Field", name: { kind: "Name", value: "questionCount" } },
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetIdeaQuery, GQLGetIdeaQueryVariables>;
export const GetIdeaProfileScoresDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getIdeaProfileScores" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "ideaId" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
				},
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "profileSlug" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "ideaProfileScores" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "ideaId" },
								value: { kind: "Variable", name: { kind: "Name", value: "ideaId" } },
							},
							{
								kind: "Argument",
								name: { kind: "Name", value: "profileSlug" },
								value: { kind: "Variable", name: { kind: "Name", value: "profileSlug" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "ideaScores" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "subject" } },
											{ kind: "Field", name: { kind: "Name", value: "score" } },
											{ kind: "Field", name: { kind: "Name", value: "questionId" } },
										],
									},
								},
								{ kind: "Field", name: { kind: "Name", value: "profileTitle" } },
								{ kind: "Field", name: { kind: "Name", value: "profileDescription" } },
								{ kind: "Field", name: { kind: "Name", value: "profileOverflowDescription" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetIdeaProfileScoresQuery, GQLGetIdeaProfileScoresQueryVariables>;
export const GetQuizDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getQuiz" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
					type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "page" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "slug" },
								value: { kind: "Variable", name: { kind: "Name", value: "slug" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "InlineFragment",
									typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quiz" } },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "title" } },
											{ kind: "Field", name: { kind: "Name", value: "intro" } },
											{ kind: "Field", name: { kind: "Name", value: "videoUrl" } },
											{ kind: "Field", name: { kind: "Name", value: "overflowIntro" } },
											{ kind: "Field", name: { kind: "Name", value: "nextQuiz" } },
											{
												kind: "Field",
												name: { kind: "Name", value: "questions" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{ kind: "Field", name: { kind: "Name", value: "id" } },
														{ kind: "Field", name: { kind: "Name", value: "subject" } },
														{ kind: "Field", name: { kind: "Name", value: "description" } },
														{ kind: "Field", name: { kind: "Name", value: "overflowDescription" } },
														{ kind: "Field", name: { kind: "Name", value: "prompt" } },
														{ kind: "Field", name: { kind: "Name", value: "answerA" } },
														{ kind: "Field", name: { kind: "Name", value: "answerB" } },
														{ kind: "Field", name: { kind: "Name", value: "answerC" } },
														{ kind: "Field", name: { kind: "Name", value: "answerD" } },
														{ kind: "Field", name: { kind: "Name", value: "answerE" } },
													],
												},
											},
										],
									},
								},
								{
									kind: "Field",
									alias: { kind: "Name", value: "profileId" },
									name: { kind: "Name", value: "parent" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "id" } },
											{ kind: "Field", name: { kind: "Name", value: "slug" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetQuizQuery, GQLGetQuizQueryVariables>;
export const GetRatingCopyDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getRatingCopy" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "ideaId" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "ratingDetails" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "ideaId" },
								value: { kind: "Variable", name: { kind: "Name", value: "ideaId" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "intro" } },
								{ kind: "Field", name: { kind: "Name", value: "title" } },
								{ kind: "Field", name: { kind: "Name", value: "subtitle" } },
								{ kind: "Field", name: { kind: "Name", value: "description" } },
								{ kind: "Field", name: { kind: "Name", value: "score" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetRatingCopyQuery, GQLGetRatingCopyQueryVariables>;
export const GetQuestionAnswerDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getQuestionAnswer" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "questionId" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
				},
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "ideaId" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "questionAnswer" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "questionId" },
								value: { kind: "Variable", name: { kind: "Name", value: "questionId" } },
							},
							{
								kind: "Argument",
								name: { kind: "Name", value: "ideaId" },
								value: { kind: "Variable", name: { kind: "Name", value: "ideaId" } },
							},
						],
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetQuestionAnswerQuery, GQLGetQuestionAnswerQueryVariables>;
export const PageDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "page" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "urlPath" } },
					type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
				},
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "previewToken" } },
					type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
				},
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "contentType" } },
					type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "page" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "urlPath" },
								value: { kind: "Variable", name: { kind: "Name", value: "urlPath" } },
							},
							{
								kind: "Argument",
								name: { kind: "Name", value: "token" },
								value: { kind: "Variable", name: { kind: "Name", value: "previewToken" } },
							},
							{
								kind: "Argument",
								name: { kind: "Name", value: "contentType" },
								value: { kind: "Variable", name: { kind: "Name", value: "contentType" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "title" } },
								{ kind: "Field", name: { kind: "Name", value: "seoTitle" } },
								{ kind: "Field", name: { kind: "Name", value: "searchDescription" } },
								{ kind: "Field", name: { kind: "Name", value: "__typename" } },
								{ kind: "FragmentSpread", name: { kind: "Name", value: "HomePage" } },
								{ kind: "FragmentSpread", name: { kind: "Name", value: "ContentPage" } },
								{ kind: "FragmentSpread", name: { kind: "Name", value: "Quiz" } },
								{ kind: "FragmentSpread", name: { kind: "Name", value: "Profile" } },
								{ kind: "FragmentSpread", name: { kind: "Name", value: "IdeaDashboard" } },
								{ kind: "FragmentSpread", name: { kind: "Name", value: "DashboardPage" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "imageRenditionFields" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageRenditionObjectType" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "url" } },
					{ kind: "Field", name: { kind: "Name", value: "width" } },
					{ kind: "Field", name: { kind: "Name", value: "height" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "image" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "richText" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "RichTextBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "value" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "imageWithCaption" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageWithCaptionBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "blocks" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "field" } },
								{ kind: "Field", name: { kind: "Name", value: "rawValue" } },
								{
									kind: "InlineFragment",
									typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ImageChooserBlock" } },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "image" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{
															kind: "Field",
															name: { kind: "Name", value: "rendition" },
															arguments: [
																{
																	kind: "Argument",
																	name: { kind: "Name", value: "fill" },
																	value: { kind: "StringValue", value: "1400x840", block: false },
																},
															],
															selectionSet: {
																kind: "SelectionSet",
																selections: [
																	{ kind: "FragmentSpread", name: { kind: "Name", value: "imageRenditionFields" } },
																],
															},
														},
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "heading" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CharBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "value" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "HomePage" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "HomePage" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "searchImage" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "url" } },
								{ kind: "Field", name: { kind: "Name", value: "width" } },
								{ kind: "Field", name: { kind: "Name", value: "height" } },
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "introText" } },
					{ kind: "Field", name: { kind: "Name", value: "explainerText" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "heroImage" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "Field",
									name: { kind: "Name", value: "rendition" },
									arguments: [
										{
											kind: "Argument",
											name: { kind: "Name", value: "fill" },
											value: { kind: "StringValue", value: "988x602", block: false },
										},
									],
									selectionSet: {
										kind: "SelectionSet",
										selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "imageRenditionFields" } }],
									},
								},
							],
						},
					},
					{ kind: "Field", name: { kind: "Name", value: "privacyText" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "privacyPage" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "urlPath" } }],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "ContentPage" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ContentPage" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "searchImage" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "url" } },
								{ kind: "Field", name: { kind: "Name", value: "width" } },
								{ kind: "Field", name: { kind: "Name", value: "height" } },
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "sidebar" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "title" } },
								{ kind: "Field", name: { kind: "Name", value: "slug" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "children" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "title" } },
											{ kind: "Field", name: { kind: "Name", value: "slug" } },
										],
									},
								},
							],
						},
					},
					{
						kind: "Field",
						name: { kind: "Name", value: "sections" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "title" } },
								{ kind: "Field", name: { kind: "Name", value: "slug" } },
								{
									kind: "Field",
									name: { kind: "Name", value: "content" },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{ kind: "Field", name: { kind: "Name", value: "blockType" } },
											{ kind: "FragmentSpread", name: { kind: "Name", value: "richText" } },
											{ kind: "FragmentSpread", name: { kind: "Name", value: "imageWithCaption" } },
											{ kind: "FragmentSpread", name: { kind: "Name", value: "heading" } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "Quiz" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Quiz" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "slug" } },
					{ kind: "Field", name: { kind: "Name", value: "title" } },
					{ kind: "Field", name: { kind: "Name", value: "intro" } },
					{ kind: "Field", name: { kind: "Name", value: "videoUrl" } },
					{ kind: "Field", name: { kind: "Name", value: "overflowIntro" } },
					{ kind: "Field", name: { kind: "Name", value: "nextQuiz" } },
					{
						kind: "Field",
						name: { kind: "Name", value: "questions" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "subject" } },
								{ kind: "Field", name: { kind: "Name", value: "description" } },
								{ kind: "Field", name: { kind: "Name", value: "overflowDescription" } },
								{ kind: "Field", name: { kind: "Name", value: "prompt" } },
								{ kind: "Field", name: { kind: "Name", value: "answerA" } },
								{ kind: "Field", name: { kind: "Name", value: "answerB" } },
								{ kind: "Field", name: { kind: "Name", value: "answerC" } },
								{ kind: "Field", name: { kind: "Name", value: "answerD" } },
								{ kind: "Field", name: { kind: "Name", value: "answerE" } },
							],
						},
					},
					{
						kind: "Field",
						alias: { kind: "Name", value: "profileId" },
						name: { kind: "Name", value: "parent" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "slug" } },
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "Profile" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Profile" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "title" } },
					{ kind: "Field", name: { kind: "Name", value: "description" } },
					{ kind: "Field", name: { kind: "Name", value: "overflowDescription" } },
					{ kind: "Field", name: { kind: "Name", value: "slug" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "IdeaDashboard" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IdeaDashboard" } },
			selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "intro" } }] },
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "DashboardPage" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DashboardPage" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "emptyHelpText" } },
					{ kind: "Field", name: { kind: "Name", value: "generalHelpText" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GQLPageQuery, GQLPageQueryVariables>;
export const AllPagesDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "allPages" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "contentTypes" } },
					type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "pages" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "contentType" },
								value: { kind: "Variable", name: { kind: "Name", value: "contentTypes" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "slug" } },
								{ kind: "Field", name: { kind: "Name", value: "title" } },
								{ kind: "Field", name: { kind: "Name", value: "id" } },
								{ kind: "Field", name: { kind: "Name", value: "live" } },
								{ kind: "Field", name: { kind: "Name", value: "urlPath" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLAllPagesQuery, GQLAllPagesQueryVariables>;
export const GetMenuDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getMenu" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "setting" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "name" },
								value: { kind: "StringValue", value: "MenuSettings", block: false },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{
									kind: "InlineFragment",
									typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MenuSettings" } },
									selectionSet: {
										kind: "SelectionSet",
										selections: [
											{
												kind: "Field",
												name: { kind: "Name", value: "menu" },
												selectionSet: {
													kind: "SelectionSet",
													selections: [
														{ kind: "Field", name: { kind: "Name", value: "blockType" } },
														{ kind: "FragmentSpread", name: { kind: "Name", value: "Internal" } },
														{ kind: "FragmentSpread", name: { kind: "Name", value: "External" } },
													],
												},
											},
										],
									},
								},
							],
						},
					},
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "Internal" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "InternalLinkBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "href" } },
					{ kind: "Field", name: { kind: "Name", value: "text" } },
				],
			},
		},
		{
			kind: "FragmentDefinition",
			name: { kind: "Name", value: "External" },
			typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ExternalLinkBlock" } },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{ kind: "Field", name: { kind: "Name", value: "id" } },
					{ kind: "Field", name: { kind: "Name", value: "href" } },
					{ kind: "Field", name: { kind: "Name", value: "text" } },
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetMenuQuery, GQLGetMenuQueryVariables>;
export const GetDashboardSlugDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getDashboardSlug" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "pages" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "contentType" },
								value: { kind: "StringValue", value: "content.DashboardPage", block: false },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "slug" } }],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetDashboardSlugQuery, GQLGetDashboardSlugQueryVariables>;
export const GetIdeaLandingContentDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getIdeaLandingContent" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "ideaDashboard" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [{ kind: "Field", name: { kind: "Name", value: "intro" } }],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetIdeaLandingContentQuery, GQLGetIdeaLandingContentQueryVariables>;
export const GetMeDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getMe" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "me" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "firstName" } },
								{ kind: "Field", name: { kind: "Name", value: "lastName" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetMeQuery, GQLGetMeQueryVariables>;
export const GetIndustryOptionsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getIndustryOptions" },
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "industryOptions" },
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "value" } },
								{ kind: "Field", name: { kind: "Name", value: "label" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetIndustryOptionsQuery, GQLGetIndustryOptionsQueryVariables>;
export const GetIndustrySubcategoryOptionsDocument = {
	kind: "Document",
	definitions: [
		{
			kind: "OperationDefinition",
			operation: "query",
			name: { kind: "Name", value: "getIndustrySubcategoryOptions" },
			variableDefinitions: [
				{
					kind: "VariableDefinition",
					variable: { kind: "Variable", name: { kind: "Name", value: "industry" } },
					type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } },
				},
			],
			selectionSet: {
				kind: "SelectionSet",
				selections: [
					{
						kind: "Field",
						name: { kind: "Name", value: "industrySubcategoryOptions" },
						arguments: [
							{
								kind: "Argument",
								name: { kind: "Name", value: "industry" },
								value: { kind: "Variable", name: { kind: "Name", value: "industry" } },
							},
						],
						selectionSet: {
							kind: "SelectionSet",
							selections: [
								{ kind: "Field", name: { kind: "Name", value: "value" } },
								{ kind: "Field", name: { kind: "Name", value: "label" } },
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<GQLGetIndustrySubcategoryOptionsQuery, GQLGetIndustrySubcategoryOptionsQueryVariables>;
